module.exports = __webpack_public_path__ + "assets/img/28_983_big.94f00c36.jpg";